import React, { useState } from "react";
import "./Navbar.css";
import { SearchBar } from "./SearchBar";
import logo from "../../images/youtube.png";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export const Navbar = ({ togglebar }) => {
  const { user, loginWithRedirect, isAuthenticated, logout } = useAuth0();

  return (
    <div id="navbar">
      <div className="left-nav">
        <button className="toggle" onClick={() => togglebar()}>
          <i className="fa-solid fa-bars"></i>
        </button>
        <Link to="/" className="logo">
          <img src={logo} alt="" />
          <span>YouTube</span>
        </Link>
      </div>

      <div className="searchbar">
        <SearchBar />
      </div>
      {isAuthenticated ? (
        <div>
          <div className="userDetail">
            <div className="user">
              <img src={user.picture} alt="" />
              <span>{user.name}</span>
            </div>
            <button
              className="logout"
              onClick={() =>
                logout({
                  logoutParams: { returnTo: window.location.origin },
                })
              }
            >
              Log Out
            </button>
          </div>
        </div>
      ) : (
        <button className="login" onClick={() => loginWithRedirect()}>
          <i class="fa-solid fa-user"></i>
          <span>Sign in</span>
        </button>
      )}
    </div>
  );
};

export default Navbar;
